<template>
    <div>
        <BaseDatatable :module="`orders`" :apiurl="url" :fields="fields"></BaseDatatable>
    </div>
</template>

<script>
import BaseDatatable from '../../core/BaseDatatable'

export default {
  name: 'OrderList',
  props: ['url'],
  components: {BaseDatatable},
  data () {
    return {
      apiurl: this.url,
      fields: [
        {
          name: 'id',
          sortField: 'id',
          title: this.$translate.t('#')
        },
        {
          name: 'created_at',
          sortField: 'created_at',
          title: this.$translate.t('Dátum')
        },
        {
          name: 'billing_name',
          sortField: 'billing_name',
          title: this.$translate.t('Megrendelő neve')
        },
        {
          name: 'email',
          sortField: 'email',
          title: this.$translate.t('Email')
        },
        {
          name: 'phone',
          sortField: 'phone',
          title: this.$translate.t('Telefonszám')
        },
        {
          name: 'gross_value_formatted',
          sortField: 'gross_value',
          title: this.$translate.t('Összeg')
        },
        {
          name: '__slot:actions',
          title: this.$translate.t('Actions')
        }
      ],
      roles: {},
      page: 1,
      filters: {}
    }
  },
  created: function () {
    this.$emit('updateTitle', this.$translate.t('Order List'))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/order/OrderList.vue